import { ExtendedWarrantiesUI } from "./ExtendedWarrantiesUI";
import { StandardProps } from "@/components/componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { dispatchAnalyticsEvent } from "@/utils";
import {
  BundleServices,
  getBundleServices,
} from "@/utils/product/getBundleServices";
import { useSharedServices } from "@/utils/services/useSharedServices";
import { VariantServices } from "@/types/types.ts";

export function ExtendedWarranties({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const { variant } = useVariant(product);
  const { availableServices, actions } = useSharedServices({ product, flags });

  const services: NonNullable<VariantServices | BundleServices> =
    variant.__typename === "CompositeBundleVariant"
      ? getBundleServices(variant)
      : variant.services || [];

  const extendedWarrantyServices = services?.filter(({ __typename }) =>
    ["DeliveryService", "ExtendedWarranty"].includes(__typename),
  );

  const hasWarranties = (extendedWarrantyServices ?? []).length > 0;

  const extendedWarrantiesAnalyticsHandler = (warrantyTitle: string) => {
    dispatchAnalyticsEvent(
      "pdp.modalUpdated",
      {
        type: "addToBasketService",
        services: [
          {
            price: variant.price?.value,
            productId: product.aliases.pimProductId,
            sku: variant.aliases.skuId,
            type: warrantyTitle,
          },
        ],
      },
      {},
    );
  };

  if (!hasWarranties) return null;

  return (
    <ExtendedWarrantiesUI
      availableToOrder={variant?.availability?.availableToOrder || false}
      extendedWarrantiesAnalyticsHandler={extendedWarrantiesAnalyticsHandler}
      hasWholePoundsOnlyEnabled={flags.hasWholePoundsOnlyEnabled.value === true}
      availableServices={availableServices}
      actions={actions}
    />
  );
}
